import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-cee4371e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-item" }
const _hoisted_2 = { class: "operate-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_RenewalServiceDrawer = _resolveComponent("RenewalServiceDrawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_dialog, {
      "append-to-body": "",
      modelValue: _ctx.visible,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.visible) = $event)),
      title: _ctx.$t('notifyPopupAuthExpired.title'),
      "custom-class": "auth-expired-wrap-custom",
      "close-on-click-modal": false,
      "destroy-on-close": "",
      "show-close": false,
      width: 450
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('notifyPopupAuthExpired.body')), 1),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_button, {
            size: "small",
            onClick: _ctx.handleClose
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('notifyPopupAuthExpired.close')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            size: "small",
            type: "primary",
            onClick: _ctx.showDetails
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('notifyPopupAuthExpired.viewDetails')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_RenewalServiceDrawer, {
      modelValue: _ctx.isRenewDrawer,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isRenewDrawer) = $event))
    }, null, 8, ["modelValue"])
  ], 64))
}